import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getUser } from './get-user';

/** `PATCH /client/:cid/users/:id {email}`: 409 when another login has the email. */
export const editUserEmail = async (user_id: string, email: string): Promise<any> => {
  await lpRequest('PATCH', clientPath(`/users/${user_id}`), { body: { email: email.trim() } });

  return getUser(user_id);
};
